import { IAccountManagerDetailsState } from "../../Models/IShared";
import { ISharedAction, SET_OPEN_SIDE_NAV, SET_MINI_SIDE_NAV, SET_ACCOUNT_MANAGE_DETAILS } from "../Interfaces/ISharedActions";


const SetOpenSidenav = dispatch => (data: boolean): ISharedAction => dispatch({
    type: SET_OPEN_SIDE_NAV,
    payload: data
});

const SetMiniSidenav = dispatch => (data: boolean): ISharedAction => dispatch({
    type: SET_MINI_SIDE_NAV,
    payload: data
});

const SetAccountManagerDetails = dispatch => (data: IAccountManagerDetailsState): ISharedAction => dispatch({
    type: SET_ACCOUNT_MANAGE_DETAILS,
    payload: data
});


export const sharedActions = {
    SetOpenSidenav,
    SetMiniSidenav,
    SetAccountManagerDetails
}